import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
      
      <p class="text-center bold mb-3">* * *</p>
      
      <p class="mb-3">
        Спасите нас!
      </p>
      
      <p class="mb-3">
        Они губят наших детей!!!
      </p>
      
      <p class="mb-3">
        Они травят их своим излучением ϴ-волн, и мы ничем не можем защититься от них! 
      </p>
      
      <p class="mb-3">
        Они такие огромные, как наши дети, и нормальный человек средних лет им по пояс; а уж старика они и вовсе не заметят. 
      </p>
      
      <p class="mb-3">
        Мы ничего не можем им сделать. 
        Наши ѱ- и Ѵ-волны для них, наверное, неощутимы; 
        они сделаны из другого теста и наше оружие против них бессильно. 
        Мы лишаемся детей. Мы вымираем.
      </p>
      
      <p class="mb-3">
        Спасите нас!!!!
      </p>

      
      <p class="text-center bold mb-3">* * *</p>
      
      
      <p class="mb-3">
        Космонавты вернулись на Землю с печальным известием. 
      </p>

      <p class="mb-3">
        На планете Zero, где они исследовали новую цивилизацию, обнаружено очень много детей и подростков, но совсем мало взрослых. 
        С неполнолетней частью населения они, конечно, в контакт не вступали, а те взрослые, 
        с которыми они пытались войти в контакт с помощью ϴ-волновых прямых передатчиков, 
        почему-то на смысловые сигналы не реагировали и ответа не посылали. 
      </p>

      <p class="mb-3">
        На Земле решили, что это ещё незрелая цивилизация, и рано с ней вступать в контакт. 
      </p>

      <p class="mb-5">
        Корабль улетел. 
      </p>

      <p class="mb-3">
        Планета была спасена.
      </p>

      <p class="mb-5">
        Её обитатели и дальше могли жить, как жили, развиваясь от больших, гигантских детей, появляющихся в результате сгущения материи волнами L, 
        и постепенно сходя на нет, уменьшаясь, и в конце жизни совсем уничтожаясь, растворяясь в океане материи, из которого они возникли.
      </p>

      <p class="mb-3">
        А разве может существовать другой путь развития?
      </p>
    </div>
    `
  )
}

const itemName = {
  rus: `Туда или назад`
}

const itemDate = {
  rus: `14 октября 1989 г.`
}

const itemPlace = {
  rus: `Гурзуф`
}

const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus + '?',
    itemDate: itemDate.rus,
    itemPlace: itemPlace.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;